module.exports = __webpack_public_path__ + "static/media/tiendificar-BN.e33607ef.svg";